<template>
    <div>
        <div class="head">
            <img src="../../static/img/01.png" alt="松科智能" class="head_icon" @click="goIndex">
            <div class="navbar">
                <div class="navbar_horizontal" v-if="show_horizontal">
                    <div :class="{ navbar_horizontal_item : activeIndex == index, navbar_horizontal_item1 : activeIndex != index }" v-for="(item, index) in navbar" :key="index" @click="handleSelect(index)">
                        {{item.title}}
                    </div>
                </div>
                <div class="navbar_vertical" v-else>
                    <div @click="drawer = true">
                        <div class="heng"></div>
                        <div class="heng"></div>
                        <div class="heng"></div>
                    </div>
                    <el-drawer
                        :visible.sync="drawer"
                        :show-close="false"
                        direction="ttb">
                        <div class="search1">
                            <el-input
                                placeholder="输入关键词搜索" @change="Search()"
                                v-model="keyword" style="border:none;">
                            </el-input>
                            <img src="../../static/img/02.png" class="search_button" @click="Search()">
                        </div>
                        <div class="draw_navbar">
                            <div class="draw_navbar_item" :class="{ draw_navbar_item1 : activeIndex == index, draw_navbar_item : activeIndex != index }" v-for="(item, index) in navbar" :key="index" @click="handleSelect(index)">
                                {{item.title}}
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
            <div class="search" v-if="show_horizontal">
                 <el-input
                    placeholder="输入关键词搜索" @change="Search()"
                    v-model="keyword" style="border:none;">
                </el-input>
                <img src="../../static/img/02.png" class="search_button" @click="Search()">
            </div>
        </div>
        <div class="index" v-if="has_list">
            <div class="index1">
                <div class="index1_top" v-if="md_title !== ''">
                    <div class="index1_name">{{md_title}}</div>
                </div>
                <div :class="{ index1_content: show_horizontal, index1_content1 : !show_horizontal }">
                    <div v-for="(item, index) in list" :key="index" class="index1_content1">
                        <div class="index1_item" v-for="(item1, index1) in item" :key="index1">
                            <div class="index1_item_type">{{item1.get_mod.title}}</div>
                            <div class="index1_item_date">[{{item1.created_at | Time()}}]</div>
                            <div class="index1_item_name">
                                <router-link target="_blank" :to="{name:'Detail', params: { id: item1.id }, query: { m_index: activeIndex, md_id: item1.md_id, title: item1.get_mod.title }}">
                                    {{item1.title}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
            <div class="list_page">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    layout="prev, pager, next"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="nolist" v-else>
            <el-image src="../../static/img/06.png"></el-image>
            <div class="tips">暂无内容哦~</div>
        </div>
        <div class="clear"></div>
        <Foot></Foot>
    </div>
</template>

<script>
export default {
    data () {
        return {
            drawer: false,
            show_horizontal: true, // 切换导航栏显示方式
            activeIndex: 0,
            navbar: [], // 导航栏列表
            list: [],
            keyword: '', // 搜索关键词
            currentPage: 1, // 当前页数
            m_id: '', // 菜单id
            md_id: '', // 模块id
            md_title: '', // 模块标题
            total: 0, // 总数
            pageSize: 0, // 每页条数
            params: '', // 搜索查询的参数
            has_list: true // 是否有列表数据
        }
    },
    created () {
        // 获取导航栏
        this.getNavBar()
        var screenWidth = window.screenWidth || document.body.clientWidth
        if (screenWidth < 768) {
            this.show_horizontal = false
        } else {
            this.show_horizontal = true
        }
        this.m_id = this.$route.query.m_id
        this.activeIndex = this.$route.query.m_index
        // 从主页的更多跳转过来的
        if (this.$route.query.md_id) {
            this.md_id = this.$route.query.md_id
            // 获取列表
            this.getList(this.$route.query.m_id, this.$route.query.md_id, 1)
        }
        // 从主页的搜索跳转过来的
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword
            var params = { kw: this.$route.query.keyword, m_id: this.$route.query.m_id, page: 1 }
            this.search(params)
        }
    },
    mounted () {
        const that = this
        window.addEventListener('resize', () => {
            var screenWidth = window.screenWidth || document.body.clientWidth
            if (screenWidth < 768) {
                that.show_horizontal = false
            } else {
                that.show_horizontal = true
            }
        }, false)
    },
    filters: {
        Time (value) {
            var arr = value.split(' ')[0].split('-')
            return arr[0] + '/' + arr[1] + '-' + arr[2]
        }
    },
    methods: {
        // 跳转到首页
        goIndex () {
            const url1 = this.$router.resolve({name: 'Index'})
            window.open(url1.href, '_blank')
        },
        // 获取导航栏
        getNavBar () {
            this.$axios.get('/menus')
            .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            this.navbar = res.data.data
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        // 选择导航栏
        handleSelect (index) {
            this.activeIndex = index
            this.m_id = this.navbar[index].id
            if (this.params) { // 搜索关键词存在
                var params = this.params
                params.m_id = this.navbar[index].id
                params.page = 1
                this.search(params)
            } else {
                // 获取列表
                this.getList(this.navbar[index].id, this.md_id, 1)
            }
            this.drawer = false
        },
        // 获取列表
        getList (id, id1, page) {
            this.$axios.get(`/${id}/get_art_list/${id1}?page=${page}`)
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            if (res.data.data.data) {
                                if (res.data.data.data.length > 0) {
                                    this.total = res.data.data.total
                                    this.currentPage = res.data.data.current_page
                                    this.pageSize = res.data.data.per_page
                                    var data = res.data.data.data
                                    var num = Math.ceil((data.length) / 2)
                                    var arr1 = [[], []]
                                    var mtitle = ''
                                    for (var j = 0; j < data.length; j++) {
                                        mtitle = data[j].get_mod.title
                                        if (j < num) {
                                            arr1[0].push(data[j])
                                        } else {
                                            arr1[1].push(data[j])
                                        }
                                    }
                                    this.md_title = mtitle
                                    this.list = arr1
                                    this.has_list = true
                                } else {
                                    this.has_list = false
                                }
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        // 点击搜索按钮
        Search () {
            if (this.keyword) {
                var params = {}
                // 从首页的更多跳转过来
                if (this.md_id) {
                    params = { kw: this.keyword, m_id: this.m_id, md_id: this.md_id, page: 1 }
                    this.search(params)
                } else { // 直接搜索跳转过来
                    params = { kw: this.keyword, m_id: this.m_id, page: 1 }
                    this.search(params)
                }
            } else {
                this.$message({
                    showClose: true,
                    message: '请输入关键字',
                    type: 'warning',
                    duration: '1500',
                    offset: '80'
                })
            }
        },
        // 搜索获取列表
        search (params) {
            this.drawer = false
            this.params = params
            this.$axios.get('/article/search', {
                    params: params
                })
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            if (res.data.data.data) {
                                if (res.data.data.data.length > 0) {
                                    this.total = res.data.data.total
                                    this.currentPage = res.data.data.current_page
                                    this.pageSize = res.data.data.per_page
                                    var data = res.data.data.data
                                    var num = Math.ceil((data.length) / 2)
                                    var arr1 = [[], []]
                                    for (var j = 0; j < data.length; j++) {
                                        if (j < num) {
                                            arr1[0].push(data[j])
                                        } else {
                                            arr1[1].push(data[j])
                                        }
                                    }
                                    this.list = arr1
                                    this.has_list = true
                                } else {
                                    this.has_list = false
                                }
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        handleCurrentChange (val) {
            console.log(`当前页: ${val}`)
            if (this.params) { // 有搜索关键词
                var params = this.params
                params.page = val
                // 搜索，获取列表
                this.search(params)
            } else {
                // 获取列表
                this.getList(this.m_id, this.md_id, val)
            }
        }
    }
}
</script>

<style scoped>
    @import "./list.css";
</style>



// WEBPACK FOOTER //
// src/view/list.vue